import { useState } from 'react';
import { products } from '../../mocks/products';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function ProductsPage() {
  const [selectedCategory, setSelectedCategory] = useState('全部');
  
  const categories = ['全部', ...Array.from(new Set(products.map(p => p.category)))];
  
  const filteredProducts = selectedCategory === '全部' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  const formatDescription = (description: string) => {
    return description.split('\n').map((line, index) => {
      // 检查是否包含客服TG链接
      if (line.includes('客服TG：https://t.me/xiaoyaoxiaomei')) {
        const parts = line.split('客服TG：');
        return (
          <div key={index} className="flex items-start">
            <i className="ri-check-line text-blue-400 mr-2 mt-0.5 flex-shrink-0"></i>
            <span className="text-sm">
              {parts[0]}客服TG：
              <a 
                href="https://t.me/xiaoyaoxiaomei" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 underline"
              >
                https://t.me/xiaoyaoxiaomei
              </a>
            </span>
          </div>
        );
      }
      
      return (
        <div key={index} className="flex items-start">
          <i className="ri-check-line text-blue-400 mr-2 mt-0.5 flex-shrink-0"></i>
          <span className="text-sm">{line}</span>
        </div>
      );
    });
  };

  return (
    <div className="min-h-screen bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">软件产品推荐</h1>
          <p className="text-xl text-gray-400">发现最适合您需求的优质软件</p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <Button
              key={category}
              variant={selectedCategory === category ? 'primary' : 'outline'}
              onClick={() => setSelectedCategory(category)}
              className="whitespace-nowrap"
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {filteredProducts.map((product) => (
            <Card key={product.id} hover className="h-full flex flex-col">
              <div className="mb-6">
                <img
                  src={product.logo}
                  alt={product.name}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-2xl font-bold text-white">{product.name}</h3>
                  <span className="px-3 py-1 bg-blue-600 text-white text-xs rounded-full">
                    {product.category}
                  </span>
                </div>
              </div>
              
              <div className="flex-1 mb-6">
                <h4 className="text-lg font-semibold text-white mb-3">推荐理由：</h4>
                <div className="text-gray-300 space-y-2">
                  {formatDescription(product.description)}
                </div>
              </div>
              
              <div className="mt-auto space-y-3">
                {product.website !== '#' ? (
                  <>
                    <a 
                      href={product.website} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <Button className="w-full">
                        <i className="ri-external-link-line mr-2"></i>
                        访问官网
                      </Button>
                    </a>
                    <div className="text-center">
                      <span className="text-xs text-gray-400">
                        通过我们购买享受业内最大优惠
                      </span>
                    </div>
                  </>
                ) : (
                  <Button variant="secondary" className="w-full" disabled>
                    <i className="ri-time-line mr-2"></i>
                    敬请期待
                  </Button>
                )}
              </div>
            </Card>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-search-line text-gray-500 text-6xl mb-4"></i>
            <h3 className="text-xl font-semibold text-gray-400 mb-2">暂无相关产品</h3>
            <p className="text-gray-500">请尝试其他分类或稍后再来查看</p>
          </div>
        )}

        {/* Logo and Brand at Bottom */}
        <div className="mt-16 mb-8 rounded-lg p-8">
          <div className="flex items-center justify-center">
            <img 
              src="https://static.readdy.ai/image/912e20adcc1f339ca4234f4574745e78/5c088a2872c5f7068bab51e7fedee0fa.png" 
              alt="逍遥Poker" 
              className="w-16 h-16 rounded-full mr-4"
            />
            <span className="text-2xl font-bold text-white">逍遥哥倾力推荐</span>
          </div>
        </div>
      </div>
    </div>
  );
}
